import React from 'react';
import { useEffect } from 'react';
import { Grid, Stack } from '@mui/material';
import '../../../../resources/styling/App.scss';
import { questionService } from '../../../../services/api/insights/questionService';
import InsightsLoader from '../../InsightsLoader';
import { Box, margin } from '@mui/system';
import { Alert } from '@mui/material';
import Question from './Question';

export default function QuestionList({
  selectedTag,
  canNotEdit,
  selectedQuestions,
  setSelectedQuestions,
}) {
  const [questions, setQuestions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showAdd, setShowAdd] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    if (selectedTag == null) {
      questionService
        .getAllQuestions()
        .then((res) => {
          if (res) {
            setQuestions(res);
          } else {
            setQuestions([]);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      questionService
        .getQuestionsByTagId(selectedTag?.id)
        .then((res) => {
          if (res) {
            setQuestions(res);
          } else {
            setQuestions([]);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedTag]);

  const updateAfterEdit = (question) => {
    if (questions.findIndex((x) => x.id === question.id) > -1) {
      const newQuestions = questions.map((q) => {
        if (q.id === question.id) {
          return question;
        } else {
          return q;
        }
      });
      setQuestions([...newQuestions]);
    } else {
      setQuestions([...questions, question]);
    }
  };
  const updateAfterDelete = (id) => {
    const newQuestions = questions.filter((question) => question.id !== id);
    setQuestions([...newQuestions]);
  };

  return (
    <div className='question-bank-container'>
      {loading ? (
        <InsightsLoader />
      ) : questions.length > 0 ? (
        <>
          {!canNotEdit && (
            <h2>{selectedTag ? selectedTag.name : 'All Questions'}</h2>
          )}

          <div className='bank-questions bank-container-questions'>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <ul className='bank-question-box left-column'>
                  {questions.map(
                    (question, idx) =>
                      idx % 2 === 0 && (
                        <Question
                          selectedQuestions={selectedQuestions}
                          setSelectedQuestions={setSelectedQuestions}
                          question={question}
                          id={idx}
                          updateAfterDelete={updateAfterDelete}
                          updateAfterEdit={updateAfterEdit}
                          canNotEdit={canNotEdit}
                        />
                      )
                  )}
                </ul>

                <ul className='bank-question-box right-column'>
                  {questions.map(
                    (question, idx) =>
                      idx % 2 !== 0 && (
                        <Question
                          question={question}
                          id={idx}
                          updateAfterDelete={updateAfterDelete}
                          updateAfterEdit={updateAfterEdit}
                          canNotEdit={canNotEdit}
                          selectedQuestions={selectedQuestions}
                          setSelectedQuestions={setSelectedQuestions}
                        />
                      )
                  )}
                </ul>
              </Grid>
            </Grid>
          </div>
        </>
      ) : selectedTag == null ? (
        <Alert severity='info'>Select a tag to view questions.</Alert>
      ) : (
        <Alert severity='info'>No questions found for this tag.</Alert>
      )}
    </div>
  );
}
